module.exports = __webpack_public_path__ + "portal-static/img/answers.a89e2e5f.png";